import {
  useClient,
  useFetchKycStatus,
  useUpdateClient,
} from "creso-core/hooks";
import { CreateClientSchema } from "creso-core/zod";
import { useCallback, useState } from "react";
import z from "zod";

export const useCheckKyc = (clientId: number) => {
  const updateClient = useUpdateClient(clientId);
  const fetchKycStatus = useFetchKycStatus();

  const [isLoading, setIsLoading] = useState(false);

  const { refetch: fetchClient } = useClient(Number(clientId), false);

  const checkKyc = useCallback(
    async (data: z.infer<typeof CreateClientSchema>) => {
      try {
        setIsLoading(true);
        await updateClient.mutateAsync(data);
        await fetchKycStatus.mutateAsync(clientId);
        const result = await fetchClient();
        if (!result.data) throw new Error("Client not found");
        return result.data;
      } finally {
        setIsLoading(false);
      }
    },
    [updateClient, clientId, fetchKycStatus, fetchClient]
  );

  return [checkKyc, isLoading] as const;
};
